var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 012 18V6c0-.55.196-1.02.588-1.412A1.93 1.93 0 014 4h16c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v12c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0120 20H4zM20 8l-7.475 4.675a1.055 1.055 0 01-.525.15 1.058 1.058 0 01-.525-.15L4 8v10h16V8zm-8 3l8-5H4l8 5zM4 8.25V6.775 6.8v-.012V8.25z",
    fill: "#CDCDCD"
  })));
}

export default SvgHeaderMessageIcon;